import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import * as styles from '@/newcar/ui/contract/components/LoadingButton/index.module.styl';

interface LoadingButtonProps extends StandardProps {
  /**
   * @description スピナー表示制御
   * @required
   * @type {boolean}
   * @memberof LoadingButtonProps
   */
  loading: boolean;

  /**
   * @description ボタンラベル
   * @required
   * @type {React.ReactNode}
   * @memberof LoadingButtonProps
   */
  children: React.ReactNode;

  /**
   * @description ボタンのサイズ
   * @required
   * @type 'small' | 'large'
   * @memberof LoadingButtonProps
   */
  size?: 'small' | 'large';

  /**
   * @description 活性・非活性制御
   * @default false
   * @type {boolean}
   * @memberof LoadingButtonProps
   */
  disabled?: boolean;

  /**
   * @description GTM計測用タグ
   * @default ''
   * @type {string}
   * @memberof LoadingButtonProps
   */
  gtm?: string;

  /**
   * ボタンクリック時のコールバック
   * @required
   * @type {(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | Promise<void>}
   * @memberof LoadingButtonProps
   */
  onClick?: Function;
}
// 申込みフォームのボタン、submitとonclickどちらか指定して使用する
export default function LoadingButton(props: LoadingButtonProps): JSX.Element {
  const {
    className = '',
    loading,
    children,
    size = 'large',
    disabled = false,
    gtm = '',
    onClick,
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <div className={`columns is-mobile is-multiline confirm-wrapper ${className}`}>
      <div className="column is-full">
        <button
          className={`${styles.formButton} ${styles.isSuccessButton} ${size === 'large' ? styles.isLargeButton : styles.isSmallButton} ${loading ? 'button is-loading' : ''}`}
          type={onClick ? 'button' : 'submit'}
          data-gtm={gtm}
          disabled={disabled}
          onClick={handleClick}
        >
          <span className={styles.formButtonArrow} />
          {children}
        </button>
      </div>
    </div>
  );
}
